export enum ReturnTogetherSelector {
  LINE_ITEM_PROPERTY = "lineItemProperty",
}
